<script>
const getNoun = function pluralTextComponentGetNoun (number, one, few, many) {
  let n = Math.abs(number) % 100;

  if (n >= 5 && n <= 20) {
    return many;
  }

  n %= 10;

  if (n === 1) {
    return one;
  }

  if (n > 1 && n < 5) {
    return few;
  }

  return many;
};
const nounPropType = { type: String, required: true };
const propTypes = {
  value: {
    type: [String, Number],
    required: true,
  },
  single: nounPropType,
  few: nounPropType,
  many: nounPropType,
};

const PluralText = ({ props }) => (
  <span>
    {getNoun(props.value, props.single, props.few, props.many)}
  </span>
);

PluralText.props = propTypes;

export default PluralText;
</script>
